sentryBrowserConfig();

import { sentryBrowserConfig } from "src/sentry.browser.config";
